// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","secondary":"#33C370","secondaryLight":"#7FE7AB","default":"#868686","wrapper":"_2FfplPX7-RdvloFLt_GypA","blockquote":"abRTYHSlbN_1greQY-RTa","trigger-container":"_2KPtlR5YAlyTamm5AId_73","trigger-title":"_3knxyQTDIfQ_j1-Grs9kzX","textArea":"_3LU76UG70V2Lw8HIy52pbE","full-width":"_3P-xJKNXEPVu7HQ-_6-sSr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/RecoveryPlan.mod.css
// module id = 742
// module chunks = 0